<template>
	<div :class="buttonClasses">
		<!--eslint-disable vue/singleline-html-element-content-newline -->
		<button @click="selectPlaybook" class="button primary">Use Playbook</button>
		<a :disabled="isOpening" :href="monsterCampaignUrl" @click.prevent.stop="preview" class="button secondary">
			<svg-loading v-if="isOpening" />
			<span v-if="!isOpening">{{ previewText }}</span>
		</a>
	</div>
</template>

<script>
import { mapMutations } from 'vuex';
import { templatePreviewItem } from '../../../templates/mixins/templatePreviewItem';

export default {
	mixins: [templatePreviewItem],
	props: {
		isPreview: {
			type: Boolean,
			default: true,
		},
		template: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		/**
		 * The class for the button wrapper
		 *
		 * @returns {string} The class
		 */
		buttonClasses() {
			return this.isPreview ? 'playbook-preview__buttons' : 'playbook-featured__buttons';
		},
	},
	created() {
		this.addListeners();
	},
	beforeDestroy() {
		this.removeListeners();
	},
	methods: {
		...mapMutations('playbooks', ['setSelectedPlaybook']),
		/**
		 * Selects a Playbook/Template is updates state. This will
		 * trigger the creation flow. How that works is dependant
		 * upon the plugin and (eventually) the dashboard.
		 *
		 * @returns {void}
		 */
		selectPlaybook() {
			this.setSelectedPlaybook(this.template);
		},
	},
};
</script>
